export default angular.module("SystemService", []).factory("System", [
  "$http",
  "$rootScope",
  "$filter",
  "Flash",
  function ($http, $rootScope, $filter, Flash) {
    const loading = {
      contentproviders: false,
      specialities: false,
      interventions: false,
      countries: false,
      languages: false,
      users: false,
      codes: false,
      alias: false,
    };

    // Load content providers from the database
    function loadContentProviders(callback) {
      loading.contentproviders = true;
      $http
        .get("/api/contentproviders")
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");

          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {
          loading.contentproviders = false;
        });
    }

    // Load specialities from the database
    function loadSpecialities(callback) {
      loading.specialities = true;
      $http
        .get("/api/specialities")
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");

          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {
          loading.specialities = false;
        });
    }

    // Load interventions from the database
    function loadInterventions(callback) {
      loading.interventions = true;
      $http
        .get("/api/interventions")
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");

          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {
          loading.interventions = false;
        });
    }

    // Load countries from the database
    function loadCountries(callback) {
      loading.countries = true;
      $http
        .get("/api/countries")
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");

          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {
          loading.countries = false;
        });
    }

    // Load languages from the database
    function loadLanguages(callback) {
      loading.languages = true;
      $http
        .get("/api/languages")
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");

          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {
          loading.languages = false;
        });
    }

    // Load users from the database
    function loadUsers(callback) {
      loading.users = true;
      $http
        .get("/api/users")
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");

          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {
          loading.users = false;
        });
    }

    // Load user rights from the database
    function loadUserRights(userid, callback) {
      loading.users = true;
      $http
        .get(`/api/users/${userid}/rights`)
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");

          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {
          loading.users = false;
        });
    }

    // Load flow group from the database
    function loadFlowGroup(callback) {
      $http
        .get("/api/flowgroup")
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");

          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {});
    }

    // Load flow property from the database
    function loadFlowProperty(callback) {
      $http
        .get("/api/flowproperty")
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");

          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {});
    }

    // Load flow operator from the database
    function loadFlowOperator(callback) {
      $http
        .get("/api/flowoperator")
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");

          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {});
    }

    // Load flow operator from the database
    function loadFlowAlias(scriptId, callback) {
      $http
        .get(`/api/flowalias/${scriptId}/`)
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");

          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {});
    }

    // Load testing names for alias
    function loadAliasTestingNames(aliasId, lang, callback) {
      $http
        .get(`/api/aliases/${aliasId}/testing_names/${lang}`)
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");

          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {});
    }

    // Load system organizations
    function loadOrganizations(callback) {
      $http
        .get("/api/organizations")
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");

          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {});
    }

    function updateOrganization(organization, callback) {
      $http.put(`/api/organizations/${organization.ID}`, organization).then(
        (res) => {
          const message = `Update successful for organization ID: ${organization.ID}`;
          Flash.create("success", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          const message = `Error! Updating title failed with error code: ${res.status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    function deleteOrganization(organization, callback) {
      $http.delete(`/api/organizations/${organization.ID}`, organization).then(
        (res) => {
          const commentText = "Deletion successful for organization";
          Flash.create("success", commentText, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          const commentText =
            `Error! Deleting organization failed with error code: ${
              organization.status}`;
          Flash.create("danger", commentText, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    // Load user organizations from the database
    function loadUserOrganizations(userid, callback) {
      loading.users = true;
      $http
        .get(`/api/users/${userid}/organizations`)
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");

          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {
          loading.users = false;
        });
    }

    function loadCodeSystems(callback) {
      $http
        .get("/api/code-systems")
        .success(callback)
        .error((data, status) => {
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");
          callback([], status);
        });
    }

    function loadCodeSystemOIDs(id, callback) {
      $http
        .get(`/api/code-systems/${id}/oids`)
        .success(callback)
        .error(() => {});
    }

    function loadCodeSystemCodes(id, callback) {
      $http
        .get(`/api/code-systems/${id}/codes`)
        .success(callback)
        .error(() => {});
    }

    // Load groups from the database
    function loadCodeSystemGroups(callback) {
      loading.groups = true;
      $http
        .get("/api/code-systems/groups")
        .success((data, status) => {
          if (callback) {
            // Generate pseudo-IDs for the groups; only used on client-side
            callback(data.map((g, i) => ({ ...g, ID: i })), status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");

          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {
          loading.groups = false;
        });
    }

    // Load all codes
    function loadAllCodesAliases(api, callback) {
      loading.codes = true;
      $http
        .get(`/api/${api}`)
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {
          loading.codes = false;
        });
    }

    // Load alias codes
    function loadAliasCodes(aliasid, callback) {
      $http
        .get(`/api/aliases/${aliasid}/codes`)
        .success((data, status) => {
          if (callback) {
            callback(data, status);
          }
        })
        .error((data, status) => {
          // Show error message to user
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) {
            callback(data, status);
          }
        })
        .finally(() => {});
    }

    function saveNewCodeAlias(code, callback) {
      $http.post("/api/aliases/", code).then(
        (res) => {
          const message = `Add new code alias successful for Code Alias: ${code.ALIAS_NAME}`;
          Flash.create("success", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          if (res.status === 409) {
            const warningMessage = "Conflict! Alias with the same name already exists. Update aborted!";
            Flash.create("warning", warningMessage, "basicAlert");
          } else {
            let message = "Error! Adding Code Alias failed: ";
            if (res.data.errortext) {
              message += res.data.errortext;
            } else {
              message += res.status;
            }
            Flash.create("danger", message, "basicAlert");
          }
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    function saveCodeAlias(alias, callback) {
      $http.put("/api/aliases/", alias).then(
        (res) => {
          const message = `Update successful for Alias: ${alias.ALIAS_ID || alias.SYS_ID}`;
          Flash.create("success", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          let message = "Error! Update for Alias failed: ";
          if (res.data.errortext) {
            message += res.data.errortext;
          } else {
            message += res.status;
          }
          Flash.create("danger", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    function saveCode(code, callback) {
      $http.put(`/api/codes/${code.ID}`, code).then(
        (res) => {
          const message = `Update successful for Code: ${code.CODE}`;
          Flash.create("success", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          const message = `Error! Updating Code failed: ${res.status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    function deleteCode(code, callback) {
      const getEndpoint = code =>
        code.INTERPRETATION_ID === null || code.INTERPRETATION_ID === undefined
          ? `/api/codes/${code.ID}`
          : `/api/codes/${code.ID}/interpretation/${code.INTERPRETATION_ID}`
  
      $http.delete(getEndpoint(code)).then(
        (res) => {
          const commentText = `Deletion successful for Code: ${code.CODE}`;
          Flash.create("success", commentText, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          const commentText =
            `Error! Deleting Code failed with error code: ${res.status}`;
          Flash.create("danger", commentText, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    function addCodeAliasCode(code, callback) {
      $http.put(`/api/aliases/${code.ALIAS_ID}/codes`, code).then(
        (res) => {
          const message = `Add successful for Code Alias Code: ${code.CODE}`;
          Flash.create("success", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          let message = "Error! Adding Code Alias Code failed: ";
          if (res.data.errortext) {
            message += res.data.errortext;
          } else {
            message += res.status;
          }
          Flash.create("danger", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    function addNewCodeAliasCode(code, callback) {
      $http.post("/api/codes/", code).then(
        (res) => {
          const message = `Add successful for New Code: ${code.CODE}`;
          Flash.create("success", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          const message = `Error! Adding New Code failed: ${res.status} ${res.data.errortext || ""}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    function removeCodeAliasCode(code, callback) {
      const getEndpoint = code =>
        code.INTERPRETATION_ID === null || code.INTERPRETATION_ID === undefined
          ? `/api/aliases/${code.ALIAS_ID}/codes/${code.ID}`
          : `/api/aliases/${code.ALIAS_ID}/codes/${code.ID}/interpretation/${code.INTERPRETATION_ID}`
  
      $http.delete(getEndpoint(code)).then(
        (res) => {
          const message = `Remove successful for Code Alias Code: ${code.CODE}`;
          Flash.create("success", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          const message = `Error! Removing Code Alias Code failed: ${res.status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    function loadFunctions(callback) {
      $http
        .get("/api/functions")
        .success(callback)
        .error((data, status) => {
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");
        });
    }

    function loadFunctionById(id, callback) {
      $http
        .get(`/api/functions/${id}`)
        .success(callback)
        .error((data, status) => {
          const message = `Error! Fetching data failed. Error code: ${status}`;
          Flash.create("danger", message, "basicAlert");
        });
    }

    function addFunction(record, callback) {
      $http
        .post("/api/functions", record)
        .success((data, status) => {
          const message = `New function ${record.NAME} added.`;
          Flash.create("success", message, "basicAlert");

          callback(data, status);
        })
        .error((data) => {
          Flash.create("danger", `Failed to add function: ${data.errortext}`, "basicAlert");
        });
    }

    function editFunction(record, callback) {
      $http
        .put(`/api/functions/${record.ID}`, record)
        .success((data, status) => {
          const message = `Function ${record.NAME} updated.`;
          Flash.create("success", message, "basicAlert");

          callback(data, status);
        })
        .error((data) => {
          Flash.create("danger", `Failed to update function: ${data.errortext}`, "basicAlert");
        });
    }

    function addNewCodeSystemOID(record, callback) {
      $http.post(`/api/code-systems/${record.CODE_SYSTEM_ID}/oids`, record).then(
        (res) => {
          const message = `Add successful for New Code System OID: ${record.OID}`;
          Flash.create("success", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          const message = `Error! Adding New Code System OID failed: ${res.status} ${res.data.errortext || ""}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    function saveOID(oid, callback) {
      $http.put(`/api/code-systems/${oid.CODE_SYSTEM_ID}/oids/${oid.ID}`, oid).then(
        (res) => {
          const message = `Update successful for OID: ${oid.OID}`;
          Flash.create("success", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          const message = `Error! Updating OID failed: ${res.status}`;
          Flash.create("danger", message, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    function deleteOID(oid, callback) {
      $http.delete(`/api/code-systems/${oid.CODE_SYSTEM_ID}/oids/${oid.ID}`).then(
        (res) => {
          const commentText = `Deletion successful for OID: ${oid.OID}`;
          Flash.create("success", commentText, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
        (res) => {
          const commentText =
            `Error! Deleting OID failed with error code: ${res.status}`;
          Flash.create("danger", commentText, "basicAlert");
          if (callback) return callback(res.data, res.status);
        },
      );
    }

    function loadOrganizationTags(callback) {
      $http
        .get("/api/organizations/", { cache: true })
        .success(response => callback(response))
        .error((data) => {
          const message = `Error! Fetching data failed. Error code: ${data.status}`;
          Flash.create("danger", message, "basicAlert");
        });
    }

    return {
      loading,
      loadContentProviders,
      loadSpecialities,
      loadInterventions,
      loadCountries,
      loadLanguages,
      loadUsers,
      loadUserRights,
      loadFlowGroup,
      loadFlowProperty,
      loadFlowOperator,
      loadFlowAlias,
      loadAliasTestingNames,
      loadOrganizations,
      updateOrganization,
      deleteOrganization,
      loadUserOrganizations,
      loadAliasCodes,
      saveCode,
      deleteCode,
      saveNewCodeAlias,
      saveCodeAlias,
      addCodeAliasCode,
      addNewCodeAliasCode,
      removeCodeAliasCode,
      loadAllCodesAliases,
      loadFunctions,
      loadFunctionById,
      addFunction,
      editFunction,
      loadCodeSystems,
      loadCodeSystemOIDs,
      loadCodeSystemCodes,
      loadCodeSystemGroups,
      addNewCodeSystemOID,
      saveOID,
      deleteOID,
      loadOrganizationTags,
    };
  },
]);
